import { createFileRoute, notFound } from '@tanstack/react-router';

import { DetailsNavigationBar } from '@/features/agents';
import { getAgentOptions, toAgentId } from '@/hooks/api';
import { createClientFromAuth } from '@/utils';

export const Route = createFileRoute('/_auth/details/agents/$agentId')({
  loader: async ({ context: { auth, queryClient }, params: { agentId } }) => {
    // TODO: Find a way to get client from loader data from parent route
    const client = await createClientFromAuth(auth);
    const agent = await queryClient.ensureQueryData(getAgentOptions(client, queryClient, toAgentId(agentId)));
    if (!agent) throw notFound();
    return { agent };
  },
  component: DetailsNavigationBar,
  notFoundComponent: () => {
    return <p>Agent not found!</p>;
  },
});
